<template>
  <el-dialog title="添加处方单" center width="40%" :visible.sync="dialogVisible">
    <p v-if="type==='online'">
      是否确定关闭视频，并跳转到开处方界面？
      <span class="fs12 color_main">（结束问诊前都可以再次进入视频间）</span>
    </p>
    <p :class="[type==='online'?'mt10':'center']">请选择您要添加的处方类型</p>
    <div slot="footer" class="dialog-footer flex space-around">
      <template v-if="docJobType==='CHINESE_DOC'">
        <el-button type="primary" size="medium" @click="handler('CHINESE_RECIPE')">中药方
        </el-button>
        <el-button type="primary" size="medium" @click="handler('DISPENSING_GRANULES')">配方颗粒方
        </el-button>
      </template>
      <el-button type="primary" size="medium" @click="handler('WESTERN_RECIPE')">西药方</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "plat-agree-dialog",
  props: {
    aspectUser: String,
    type: {
      type: String,
      default: 'online'
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        systemScore: ''
      }
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handler(type) {
      //type: CHINESE_RECIPE(中药方) WESTERN_RECIPE(西药方)
      this.$emit('handler', '跳转到处方', type);
      this.hide();
    },
  },
}
</script>

<style scoped>

</style>
